import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { userResetPassword } from "@api/v1/methods";

export const useResetPassword = (
  options?: UseMutationOptions<undefined, AxiosApiError, unknown>
) =>
  useMutation({
    mutationFn: userResetPassword,
    ...options,
  });
